import menu from './menu'
import table from './table'

export default {
    statisticProcesses: 'Statistikmeldungen',
    statisticSurvey: 'Erhebung',
    statisticSurveyPeriod: 'Erhebungszeitraum',
    statisticSurveyRecordingPeriod: 'Erfassungszeitraum',
    statisticProcessCount: '{count} Statistikmeldungen|{count} Statistikmeldung|{count} Statistikmeldungen',
    statisticForm: 'Statistikformular',

    dedicatedProcess: 'Zugehöriger Vorgang',
    forStatisticSurveyPeriod: 'Für den Erhebungszeitraum',
    serial_number: 'LfdNr.',
    name: 'Interner Name',
    event_id: 'Veranstaltungs-ID',
    organisation_id: 'Organisations-ID',
    creator_user_id: 'Ersteller*in-ID',
    statistic_formable_id: 'Statistikformular-ID',
    statistic_formable_type: 'Statistikformular-Typ',
    statistic_survey_period_id: 'Erhebungszeitraum-ID',
    status_id: 'Status-ID',

    addNewStatistic: 'Neue Meldung hinzufügen',
    createStatistic: 'Statistikmeldung erstellen',
    deleteStatisticProcess: 'Statistikmeldung löschen',
    deleteStatisticProcessText: 'Möchtest du die Statistikmeldung wirklich löschen?',
    deleteStatisticProcessSuccess: 'Statistikmeldung erfolgreich gelöscht',
    deleteStatisticProcessError: 'Statistikmeldung konnte nicht gelöscht werden',

    createSuccess: 'Statistikmeldung erfolgreich erstellt',
    createError: 'Statistikmeldung konnte nicht erstellt werden',
    saveSuccess: 'Statistikmeldung erfolgreich gespeichert',
    saveError: 'Statistikmeldung konnte nicht gespeichert werden',
    saveDraft: 'Entwurf speichern',

    statisticProcessId: 'Statistikmeldung "{id}"',

    statisticFormLocked: 'Die Statistikmeldung ist gesperrt.',
    statisticFormLockedText: 'Die Statistikmeldung wurde abgeschickt und kann nicht weiter bearbeitet werden.',

    fehlanzeigeAlreadySubmitted: 'Die Fehlanzeige wurde schon abgegeben.',
    fehlanzeigeCannotBeSubmitted: 'Fehlanzeige kann nicht abgegeben werden, da bereits Meldungen für diesen Erhebungszeitraum vorliegen.',
    submitFehlanzeige: 'Fehlanzeige abgeben',

    statisticProcessNavigator: {
        saveDraft: 'Entwurf speichern',
        backToStatistics: 'Zurück zur Statistikübersicht',
    },

    tools: {
        tools: 'Werkzeuge',
        sendTestRequest: 'Testmeldung abschicken',
        eCoreHeading: 'Meldung einreichen (eCore)',
        eCoreDescription: 'Testmeldung an eCore-Schnittstelle von StaLa senden',
        eCoreHelpText: 'Du kannst hier die Meldung <b>zum Testen</b> an die eCore-Schnittstelle des Statistischen Landesamtes senden. Du bekommst dann angezeigt, welche Fehler bei der ersten Übermittlung aufgetreten sind. Diese Meldung wird nicht gespeichert und kann nicht weiterverarbeitet werden.<br><br>' +
            'Wenn du die Meldung wirklich an eCore senden möchtest, musst du die Meldung in den Status "Übermittelt" setzen.',
        errorOnSendingTestRequest: 'Fehler beim Senden der Testmeldung',
    },

    menu,
    table,
}